import { IconProps } from '../icon';

export function ChevronIcon(props: IconProps) {
  return (
    <svg
      id="chevron"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="40"
      height="22.857"
      viewBox="0 0 40 22.857"
      {...props}
    >
      <defs>
        <clipPath id="clipPath">
          <rect
            id="Rectangle_199"
            data-name="Rectangle 199"
            width="40"
            height="22.857"
            fill="#41B883"
          />
        </clipPath>
      </defs>
      <g id="Groupe_389" data-name="Groupe 389" clipPath="url(#clipPath)">
        <path
          id="Tracé_159"
          data-name="Tracé 159"
          d="M20,22.856a2.848,2.848,0,0,1-2.02-.837L.837,4.876A2.857,2.857,0,0,1,4.877.836L20,15.959,35.123.836a2.857,2.857,0,0,1,4.04,4.04L22.02,22.019a2.848,2.848,0,0,1-2.02.837"
          transform="translate(0 0.001)"
          fill="#41B883"
        />
      </g>
    </svg>
  );
}

export default ChevronIcon;
